<template>
  <div v-if="Object.entries(usedTags).length > 0" class="mt-6">
    <v-list v-for="[tagGroupId, tagGroup] of Object.entries(usedTags)" :key="tagGroupId" class="py-0">
      <v-list-group color="grey darken-4">
        <template v-slot:prependIcon>
          <v-icon v-text="tagGroup.icon" color="grey darken-1"></v-icon>
        </template>
        <template v-slot:activator>
          <v-list-item-title>{{ tagGroup.name }}</v-list-item-title>
        </template>
        <v-list-item-group v-model="selectedTagsValue" multiple>
          <v-list-item
            :value="parseInt(tagId)"
            v-for="[tagId, tag] of Object.entries(tagGroup.items)"
            :key="tagId"
            @click="handleTagClick(parseInt(tagId))"
            class="pl-13"
            :disabled="selectedFilter === 'tags' && !availableTags.includes(parseInt(tagId))"
            link
          >
            <v-list-item-icon class="mr-1">
              <v-icon v-text="tag.icon" dense></v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ tag.name }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list-group>
    </v-list>
  </div>
</template>

<script>
export default {
  props: {
    usedTags: {
      type: Object,
      required: true,
    },
    selectedTags: {
      type: Array,
      required: true,
    },
    availableTags: {
      type: Array,
      required: true,
    },
    selectedFilter: {
      type: String,
      required: true,
    },
  },
  computed: {
    selectedTagsValue: {
      get() {
        return this.selectedTags;
      },
      set(value) {
        this.$emit('update:selectedTags', value);
      },
    },
  },
  methods: {
    handleTagClick() {
      this.$emit('update:selectedFilter', 'tags');
    },
  },
};
</script>

<style>
.v-list-group__header__prepend-icon {
  margin-right: 12px !important;
}
</style>
